import { render } from "./Scadenzario.vue?vue&type=template&id=51140472"
import script from "./Scadenzario.vue?vue&type=script&lang=js"
export * from "./Scadenzario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__